import React, { useState, useEffect } from "react";
import fetchData from "../../services/requester-website";
import { Link } from "react-router-dom";
import { imagePath } from "../../helpers/global";
import { defaultSettings } from "../../helpers/default-settings";

const HomeDestinations = (props) => {
  const [data, setData] = useState([]);

  const getData = () => {
    let reqURL = "destinations";
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        data && setData(data?.filter((x) => x?.showOnHome) || []);
      },
      "GET"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div className="home-destinations">
        <h2 className="home-title">
          {props?.destinationsTitle || defaultSettings?.destinationsTitle}
        </h2>
        <p className="home-sub-title">
          {props?.destinationsSubTitle || defaultSettings?.destinationsSubTitle}
        </p>
        <div className="row">
          {data?.map(
            (x, key) =>
              key < 4 && (
                <div key={key} className="col-lg-6">
                  <div className="home-destinations-wrap">
                    <img src={imagePath() + x?.imageURL} alt={x?.title} />
                    <h3>{x?.title}</h3>
                    <Link to={"destination/" + x?.destinationId} />
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default HomeDestinations;
